import { render, staticRenderFns } from "./FormularioFiltroRelatorioManutencao.vue?vue&type=template&id=0720a689&"
import script from "./FormularioFiltroRelatorioManutencao.vue?vue&type=script&lang=ts&"
export * from "./FormularioFiltroRelatorioManutencao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports